module.exports = __webpack_public_path__ + "img/x-big.879dc6cf.svg";